import { Component, EventEmitter, Input, OnDestroy, OnInit, Output , ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'wab-timer',
    templateUrl: './whack-a-bingo-timer.component.html',
    styleUrls: ['./whack-a-bingo-timer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WhackABingoTimerComponent implements OnInit, OnDestroy {

  timeInterval: any;
  @Input() wabgData: any;
  @Input() imagePath: any;
  @Output() onEnd = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
    this.wabTimer();
  }

  wabTimer() {
    this.timeInterval = setInterval(() => {
      this.remainingTime = this.remainingTime - 1;
      if (this.remainingTime <= 0) {
        clearInterval(this.timeInterval);
        this.onEnd.emit();
      }
    }, 1000);
  }

  set remainingTime(val: number) {
    this.wabgData.remainingTime = val;
  }

  get remainingTime(): number {
    return this.wabgData.remainingTime;
  }

  get playTime(): number {
    return this.wabgData.playTime;
  }

  getImg(name: string): string {
    return this.imagePath[name];
  }

  ngOnDestroy(): void {
    clearInterval(this.timeInterval);
  }

}
